// extracted by mini-css-extract-plugin
export default {"ConfirmationPop":"ConfirmationPop_ConfirmationPop__LOAZs","modalBody":"ConfirmationPop_modalBody__ep9Xy"};